import React, { useState } from "react";
import Footer from "../../partials/footer";
import Navigation from "../../partials/navigation";
import { Helmet } from "react-helmet";
import { appName } from "../../app.json";
import LoadingSpinner from "../../partials/loading";
import AlertMessage from "../../partials/alertMessage";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { SITE_SIBLINGS } from "../../queries/site.query";
import { CHANGE_SITE } from "../../queries/staff.query";
import { Redirect } from "react-router-dom";
import auth from "../../providers/Auth.Provider";

function ChangeSite({ history, location }) {
    const [newSite, setNewSite] = useState(null);
    const [err, setErr] = useState(null);
    const { LogOut, IsAuthenticationError, GetToken, GetAuthenticatedStaff } = auth.authProvider;

    const { site } = GetToken() && GetAuthenticatedStaff();
    const { loading, data, error } = useQuery(SITE_SIBLINGS, {
        variables: {
            parent: site && site.parent.id,
        },
    });

    const [postChange, { loading: cLoading }] = useMutation(CHANGE_SITE, {
        onError: (error) => setErr(error.message),
        onCompleted: (data) => {
            alert(data.ChangeStaffSite.message);
            LogOut();
            history.push("/login");
        },
    });
    if (error && IsAuthenticationError(error.message)) {
        // clear session
        LogOut();
        return (
            <Redirect
                to={{
                    pathname: "/login",
                    search: `?redirect=${location.pathname}`,
                    state: {
                        from: {
                            pathname: location.pathname,
                        },
                    },
                }}
            />
        );
    }
    return (
        <div className="page-wrapper position-absolute w-100">
            <Helmet>
                <title>Change of Site | {appName}</title>
            </Helmet>
            <Navigation history={history} />
            <div className="page-container">
                <div className="page-content-wrapper page-content-wrapper-home">
                    <div className="page-content page-content-home">
                        <div className="row justify-content-center">
                            <div className="col-md-10">
                                <div className="row">
                                    <div className="col-12">
                                        <button
                                            type="button"
                                            onClick={() => history.push("/home")}
                                            className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle margin-right-10 btn-default"
                                        >
                                            <i className="material-icons text-success">home</i> Back Home
                                        </button>
                                    </div>
                                    <div className="col-12">
                                        <h2>Change of Site</h2>
                                        <p>Update Working Site</p>
                                        <LoadingSpinner loading={loading || cLoading} bar={true} />
                                        <AlertMessage message={err} failed={true} />
                                    </div>
                                    <div className="col-12">
                                        <form
                                            className="row"
                                            onSubmit={(event) => {
                                                event.preventDefault();
                                                if (newSite) {
                                                    if (newSite !== site.id) {
                                                        // update here
                                                        postChange({
                                                            variables: {
                                                                site: newSite,
                                                            },
                                                        });
                                                    } else {
                                                        setErr("Please select a different site!");
                                                    }
                                                } else {
                                                    setErr("Select Site before submitting form!");
                                                }
                                            }}
                                        >
                                            {data &&
                                                data.GetSiblingSites.docs.map((item, idx) => (
                                                    <div key={idx} className="col-6 col-md-4 col-lg-3">
                                                        <div className="card">
                                                            <div className="card-body text-center m-t-10">
                                                                <center>
                                                                    <div
                                                                        className="img-container"
                                                                        style={{
                                                                            backgroundImage: `url(${item.logo})`,
                                                                        }}
                                                                    ></div>
                                                                </center>
                                                                <h5>{item.name}</h5>
                                                                <span className="badge badge-success">{item.type.name}</span>
                                                            </div>
                                                            <div className="card-footer text-center m-b-10">
                                                                <div class="custom-control custom-radio custom-control-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id={idx}
                                                                        onChange={({ target }) => {
                                                                            if (target.checked) setNewSite(item.id);
                                                                        }}
                                                                        name="customRadioInline1"
                                                                        className="custom-control-input"
                                                                    />
                                                                    <label className="custom-control-label" for={idx}>
                                                                        Select Site
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            {!loading && (
                                                <div className="col-12 fade-in">
                                                    <button type="submit" disabled={loading || cLoading} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success">
                                                        Submit
                                                        <i className="material-icons">arrow_right_alt</i>
                                                    </button>
                                                </div>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* home footer goes here */}
                <Footer />
            </div>
        </div>
    );
}

export default ChangeSite;
